export type LocalizedApiName = {
  pt: string;
  es: string;
};

export function getLocalizedApiName(name: LocalizedApiName | string | null | undefined, language: string) {
  if (!name) return "";
  if (typeof name === "string") return name;
  return language.startsWith("es") ? name.es || name.pt : name.pt || name.es;
}
